var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_126_17338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_126_17338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.667 56C17.2003 56 15.9448 55.4778 14.9003 54.4333C13.8559 53.3889 13.3337 52.1333 13.3337 50.6667V16H10.667V10.6667H24.0003V8H40.0003V10.6667H53.3337V16H50.667V50.6667C50.667 52.1333 50.1448 53.3889 49.1003 54.4333C48.0559 55.4778 46.8003 56 45.3337 56H18.667ZM24.0003 45.3333H29.3337V21.3333H24.0003V45.3333ZM34.667 45.3333H40.0003V21.3333H34.667V45.3333Z",
    fill: "#8663E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBig);
export default __webpack_public_path__ + "static/media/delete-big.984c1070f2d08cc7e01aef9e321d7e0a.svg";
export { ForwardRef as ReactComponent };